export default __webpack_public_path__ + "d3e8e4157def6d7cc8c22fd8bff5f68f.svg";